/**
 * Tres Commas queue: pull bank layers.
 * For Media Devoted | Created By Ciro Autiero
 */

import { matchTracker, type AutoPullResource, type FlowLayer, type TrackerId } from '@trafficpulse/shared';
import api from '@/services/api';
import { TC_SYNC_ORDER } from '@/features/flow-optimizer/tabs/queue/sync/bank-sync-target';
import { pollTcSeed, type SeedState } from '@/features/flow-optimizer/tabs/queue/sync/poll-tc-seed';

type Progress = (layer: AutoPullResource) => void;
const LEGACY_PATH: Record<FlowLayer, (tracker: string) => string> = {
  paths: (t) => `/path-seed/${t}/import`, landers: (t) => `/lander-seed/${t}/import`,
  offers: (t) => `/offer-seed/${t}/offers/import`,
};
const LEGACY_ORDER: FlowLayer[] = ['paths', 'landers', 'offers'];
const TC_PATH: Record<AutoPullResource, string> = {
  'network-rules': '/offer-seed/tres-commas/network-rules', offers: '/offer-seed/tres-commas/offers',
  landers: '/lander-seed/tres-commas', paths: '/path-seed/tres-commas',
};
async function legacyPull(provider: TrackerId, layers: FlowLayer[], progress: Progress) {
  for (const layer of LEGACY_ORDER.filter((l) => layers.includes(l))) {
    progress(layer);
    await api.post(LEGACY_PATH[layer](provider), { mode: 'skip' }, { timeout: 600_000 });
  }
}
async function tcPull(progress: Progress) {
  for (const resource of TC_SYNC_ORDER) {
    progress(resource);
    const base = TC_PATH[resource];
    const { data } = await api.post<{ data: SeedState }>(`${base}/import`, { mode: 'skip' }, { timeout: 600_000 });
    await pollTcSeed(base, data.data);
  }
}
export function pullBankLayers(provider: TrackerId, layers: FlowLayer[], progress: Progress) {
  return matchTracker(provider, { voluum: () => legacyPull(provider, layers, progress),
    binom: () => legacyPull(provider, layers, progress), 'tres-commas': () => layers.length ? tcPull(progress) : Promise.resolve() });
}
